import { z } from 'zod';

export type QuestionType =
  | 'text'
  | 'date'
  | 'radio'
  | 'checkbox'
  | 'select'
  | 'email'
  | 'tel'
  | 'textarea'
  | 'heading'
  | 'subheading';

export interface Question {
  id: string;
  step: number;
  type: QuestionType;
  label: string;
  placeholder?: string;
  tooltip?: string;
  options?: string[];
  dependsOn?: { field: string; value: any } | null;
  validation?: z.ZodTypeAny;
  isHeading?: boolean;
  isSubHeading?: boolean;
}

export const COUNTRIES = [
  "ALBANIA",
  "ANDORRA",
  "ANGOLA",
  "ANGUILLA",
  "ANTIGUA AND BARBUDA",
  "ARGENTINA",
  "ARMENIA",
  "ARUBA",
  "AUSTRALIA",
  "AUSTRIA",
  "AZERBAIJAN",
  "BAHAMAS",
  "BAHRAIN",
  "BARBADOS",
  "BELARUS",
  "BELGIUM",
  "BELIZE",
  "BENIN",
  "BOLIVIA",
  "BOSNIA AND HERZEGOVINA",
  "BOTSWANA",
  "BRAZIL",
  "BRUNEI",
  "BULGARIA",
  "BURUNDI",
  "CAMBODIA",
  "CAMEROON",
  "CANADA",
  "CAPE VERDE",
  "CAYMAN ISLANDS",
  "CHILE",
  "CHINA-CHINA",
  "CHINA- SAR HONGKONG",
  "CHINA- SAR MACAU",
  "COLOMBIA",
  "COMOROS",
  "COOK ISLANDS",
  "COSTA RICA",
  "COTE D'IVOIRE",
  "CROATIA",
  "CUBA",
  "CYPRUS",
  "CZECH REPUBLIC",
  "DENMARK",
  "DJIBOUTI",
  "DOMINICA",
  "DOMINICAN REPUBLIC",
  "EAST TIMOR (DEMOCRATIC REPUBLIC OF)",
  "ECUADOR",
  "EL SALVADOR",
  "EQUATORIAL GUINEA",
  "ERITREA",
  "ESTONIA",
  "ESWATINI",
  "FIJI",
  "FINLAND",
  "FRANCE",
  "GABON",
  "GAMBIA",
  "GEORGIA",
  "GERMANY",
  "GHANA",
  "GIBRALTAR",
  "GREECE",
  "GRENADA",
  "GUATEMALA",
  "GUERNSEY",
  "GUINEA",
  "GUYANA",
  "HAITI",
  "HONDURAS",
  "HUNGARY",
  "ICELAND",
  "INDONESIA",
  "IRELAND",
  "ISLE OF MAN",
  "ISRAEL",
  "ITALY",
  "JAMAICA",
  "JAPAN",
  "JERSEY",
  "JORDAN",
  "KAZAKHSTAN",
  "KENYA",
  "KIRIBATI",
  "KUWAIT",
  "KYRGYZSTAN",
  "LAOS",
  "LATVIA",
  "LESOTHO",
  "LIBERIA",
  "LIECHTENSTEIN",
  "LITHUANIA",
  "LUXEMBOURG",
  "MADAGASCAR",
  "MALAWI",
  "MALAYSIA",
  "MALI",
  "MALTA",
  "MARSHALL ISLANDS",
  "MAURITANIA",
  "MAURITIUS",
  "MEXICO",
  "MICRONESIA (FEDERATED STATES OF)",
  "MOLDOVA",
  "MONACO",
  "MONGOLIA",
  "MONTENEGRO",
  "MONTSERRAT",
  "MOROCCO",
  "MOZAMBIQUE",
  "MYANMAR",
  "NAMIBIA",
  "NAURU",
  "NETHERLANDS",
  "NEW ZEALAND",
  "NICARAGUA",
  "NIGER",
  "NIUE ISLAND",
  "NORWAY",
  "OMAN",
  "PALAU",
  "PALESTINE",
  "PANAMA",
  "PAPUA NEW GUINEA",
  "PARAGUAY",
  "PERU",
  "PHILIPPINES",
  "POLAND",
  "PORTUGAL",
  "QATAR",
  "REPUBLIC OF KOREA",
  "REPUBLIC OF NORTH MACEDONIA",
  "ROMANIA",
  "RUSSIAN FEDERATION",
  "RWANDA",
  "SAINT KITTS AND NEVIS",
  "SAINT LUCIA",
  "SAINT VINCENT AND THE GRENADINES",
  "SAN MARINO",
  "SAUDI ARABIA",
  "SENEGAL",
  "SERBIA",
  "SEYCHELLES",
  "SIERRA LEONE",
  "SINGAPORE",
  "SLOVAKIA",
  "SLOVENIA",
  "SOLOMON ISLANDS",
  "SOUTH AFRICA",
  "SPAIN",
  "SRI LANKA",
  "SURINAME",
  "SWEDEN",
  "SWITZERLAND",
  "TAIWAN",
  "TAJIKISTAN",
  "TANZANIA",
  "THAILAND",
  "TOGO",
  "TONGA",
  "TRINIDAD AND TOBAGO",
  "TURKS AND CAICOS ISL",
  "TUVALU",
  "UKRAINE",
  "UNITED ARAB EMIRATES",
  "UNITED KINGDOM",
  "UNITED STATES OF AMERICA",
  "URUGUAY",
  "UZBEKISTAN",
  "VANUATU",
  "VATICAN CITY STATE ( HOLY SEE)",
  "VENEZUELA",
  "VIETNAM",
  "WEST SAMOA",
  "ZAMBIA",
  "ZIMBABWE"
];
export const PORTS_OF_ARRIVAL = [
  "AGATTI SEAPORT",
  "AHMEDABAD AIRPORT",
  "ALANG SEAPORT",
  "AMRITSAR AIRPORT",
  "BAGDOGRA AIRPORT",
  "BEDI BANDAR SEAPORT",
  "BENGALURU AIRPORT",
  "BHAVNAGAR SEAPORT",
  "BHUBANESHWAR AIRPORT",
  "CALICUT AIRPORT",
  "CALICUT SEAPORT",
  "CHANDIGARH AIRPORT",
  "CHENNAI AIRPORT",
  "CHENNAI SEAPORT",
  "COCHIN AIRPORT",
  "COCHIN SEAPORT",
  "COIMBATORE AIRPORT",
  "CUDDALORE SEAPORT",
  "DAHEJ SEAPORT",
  "DARRANGA LANDPORT",
  "DELHI AIRPORT",
  "DHAMRA SEAPORT",
  "GAYA AIRPORT",
  "GOA AIRPORT(DABOLIM)",
  "GOA AIRPORT (MOPA)",
  "GOA SEAPORT",
  "GUWAHATI AIRPORT",
  "HALDIA SEAPORT",
  "HAZIRA SEAPORT",
  "HYDERABAD AIRPORT",
  "INDORE AIRPORT",
  "JAIPUR AIRPORT",
  "JOGBANI LANDPORT",
  "KAKINADA SEAPORT",
  "KAMARAJAR SEAPORT",
  "KANDLA SEAPORT",
  "KANNUR AIRPORT",
  "KARAIKAL SEAPORT",
  "KATTUPALI SEAPORT",
  "KOLKATA AIRPORT",
  "KOLKATA SEAPORT",
  "KOLLAM SEAPORT",
  "KRISHNAPATNAM SEAPORT",
  "LUCKNOW AIRPORT",
  "MADURAI AIRPORT",
  "MANDVI SEAPORT",
  "MANGALORE AIRPORT",
  "MANGALORE SEAPORT",
  "MUMBAI AIRPORT",
  "MUMBAI SEAPORT",
  "MUNDRA SEAPORT",
  "NAGAPATTINAM SEAPORT",
  "NAGPUR AIRPORT",
  "NAVI MUMBAI AIRPORT",
  "NHAVA SHEVA SEAPORT",
  "PARADEEP SEAPORT",
  "PIPAVAV SEAPORT",
  "PORBANDAR SEAPORT",
  "PORTBLAIR AIRPORT",
  "PORT BLAIR SEAPORT",
  "PUNE AIRPORT",
  "RAXAUL LANDPORT",
  "RUPAIDIHA LANDPORT",
  "SIKKA SEAPORT",
  "SURAT AIRPORT",
  "TIRUCHIRAPALLI AIRPORT",
  "TRIVANDRUM AIRPORT",
  "TUNA TEKRA SEAPORT",
  "TUTICORIN SEAPORT",
  "VALLARPADAM SEAPORT",
  "VARANASI AIRPORT",
  "VIJAYAWADA AIRPORT",
  "VISHAKHAPATNAM AIRPORT",
  "VISHAKHAPATNAM SEAPORT",
  "VIZHINJAM INTERNATIONAL SEAPORT",
  "VIZHINJAM SEAPORT"
];
export const VISA_PURPOSES = [
  "e-Ayush Attendant Visa (e-M4 V) - AS ATTENDANT TO AN E-AYUSH VISA HOLDER.",
  "e-Ayush Visa (e-M3 V) - TREATMENT UNDER AYUSH SYSTEMS/INDIAN SYSTEMS OF MEDICINE.",
  "e-Business Visa (e-B1 V) - TO SET UP INDUSTRIAL/BUSINESS VENTURE",
  "e-Business Visa (e-B1 V) - SALE/PURCHASE/TRADE",
  "e-Business Visa (e-B1 V) - SPORTS RELATED ACTIVITY",
  "e-Business Visa (e-B1 V) - PARTICIPATION IN EXHIBITIONS,BUSINESS/TRADE FAIRS",
  "e-Business Visa (e-B1 V) - TO JOIN THE VESSEL",
  "e-Business Visa (e-B1 V) - TO DELIVER LECTURE/S UNDER GLOBAL INITIATIVE FOR ACADEMIC NETWORKS (GIAN)",
  "e-Business Visa (e-B1 V) - TO RECRUIT MANPOWER",
  "e-Business Visa (e-B1 V) - CONDUCTING TOURS",
  "e-Business Visa (e-B1 V) - ATTEND TECHNICAL/BUSINESS MEETINGS",
  "e-Business Visa (e-B1 V) - EXPERT/SPECIALIST IN CONNECTION WITH AN ONGOING PROJECT",
  "e-Business Visa (e-B5 V) - TO ATTEND A CONFERENCE/SEMINAR/WORKSHOP ORGANIZED BY A MINISTRY OR DEPARTMENT OF THE GOVERNMENT OF INDIA,STATE GOVERNMENTS OR UT ADMINISTRATIONS AND THEIR SUBORDINATE/ ATTACHED ORGANIZATIONS AND PSUS AND PRIVATE CONFERENCES ORGANIZED BY PRIVATE PERSONS/COMPANIES/ORGANIZATIONS.",
  "e-Business Visa (e-B5 V) - FOR ATTENDING AN INTERNATIONAL CONFERENCE/SEMINAR/WORKSHOP",
  "e-Business Visa (e-B6 V) - REALITY TV",
  "e-Business Visa (e-B6 V) - COMMERCIAL TV SERIALS",
  "e-Business Visa (e-B6 V) - WEB SHOWS/SERIES",
  "e-Business Visa (e-B6 V) - REALITY TV",
  "e-Business Visa (e-B6 V) - FEATURE FILM",
  "e-Business Visa (e-B6 V) - COMMERCIAL TV SERIALS",
  "e-Business Visa (e-B6 V) - FEATURE FILM",
  "e-Business Visa (e-B6 V) - WEB SHOWS/SERIES",
  "e-Family Visa (e-SX V) - FOR DEPENDENT OF E-STUDENT VISA",
  "e-Family Visa (e-SX V) - FOR DEPENDENT OF E-STUDENT VISA",
  "e-Medical Attendant Visa 30 Days (e-M2 V) - SHORT-TERM MEDICAL ATTENDANT TREATMENT OF SELF",
  "e-Medical Attendant Visa (e-M2 V) - TO ACCOMPANY PATIENT TRAVELLING TO INDIA ON E-M1 V",
  "e-Medical Attendant Visa (e-M4 V) - AS E-AYUSH ATTENDANT TO AN E-M3 V VISA HOLDER",
  "e-Medical Visa 30 Days (e-M1 V) - SHORT-TERM MEDICAL TREATMENT OF SELF",
  "e-Medical Visa (e-M1 V) - SHORT TERM MEDICAL TREATMENT OF SELF",
  "e-Medical Visa(e-M3 V) - TREATMENT UNDER AYUSH SYSTEMS/INDIAN SYSTEMS OF MEDICINE.",
  "e-Miscellaneous Visa 3 Months (e-X1 V) - FOR PERSON OF INDIAN ORIGIN WHO ARE NOT IN POSSESSION OF OCI CARD, AND FOR SPOUSE/CHILDREN OF AN INDIAN CITIZEN/PERSON OF INDIAN ORIGIN/ OCI CARDHOLDER (OTHER THAN THOSE REGISTERED AS OCI CARDHOLDER)",
  "e-Miscellaneous Visa (e-X1 V) - FOR PERSON OF INDIAN ORIGIN WHO ARE NOT IN POSSESSION OF OCI CARD, AND FOR SPOUSE/CHILDREN OF AN INDIAN CITIZEN/PERSON OF INDIAN ORIGIN/ OCI CARDHOLDER (OTHER THAN THOSE REGISTERED AS OCI CARDHOLDER)",
  "e-Production Investment Visa (e-B4) - TRAINING",
  "e-Production Investment Visa (e-B4) - PLANT DESIGN AND BRING-UP",
  "e-Production Investment Visa (e-B4) - IT AND ERP RAMP-UP",
  "e-Production Investment Visa (e-B4) - PRODUCTION",
  "e-Production Investment Visa (e-B4) - SENIOR MANAGEMENT AND EXECUTIVES",
  "e-Production Investment Visa (e-B4) - QUALITY CHECK AND ESSENTIAL MAINTANANCE",
  "e-Production Investment Visa (e-B4) - SUPPLY CHAIN DEVELOPMENT FOR EMPANELLING VENDORS",
  "e-Production Investment Visa (e-B4) - INSTALLATION AND COMMISSIONING",
  "e-Student Visa (e-S V) - FOR THOSE COMING TO PURSUE COURSES ON INDIAN LANGUAGES AND INDIAN KNOWLEDGE SYSTEM",
  "e-Student Visa (e-S V) - FOR THOSE COMING UNDER STUDENT EXCHANGE PROGRAMME FROM INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR BUDDHIST STUDIES IN INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR HIGHER EDUCATION (INCLUDING IN SOUTH ASIAN UNIVERSITY AND NALANDA UNIVERSITY) FROM INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR STUDIES IN YOGA IN INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR STUDIES IN VEDIC CULTURE IN INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR STUDIES IN INDIAN SYSTEMS OF MUSIC AND DANCE IN INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR SHORT TERM COURSES FROM INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Student Visa (e-S V) - FOR THOSE COMING TO PURSUE EDUCATION, TRAINING AND SKILL DEVELOPMENT IN AYUSH PRACTICES FROM INSTITUTES REGISTERED ON STUDY IN INDIA PORTAL",
  "e-Tourist Visa 1 year (e-T1 V) - SHORT TERM YOGA PROGRAMME",
  "e-Tourist Visa 1 year (e-T1 V) - MEETING FRIENDS/RELATIVES",
  "e-Tourist Visa 1 year (e-T1 V) - VOLUNTARY WORK OF SHORT DURATION (FOR A MAXIMUM PERIOD OF ONE MONTH, WHICH DO NOT INVOLVE ANY MONETARY PAYMENT OR CONSIDERATION OF ANY KIND IN RETURN).",
  "e-Tourist Visa 1 year (e-T1 V) - SHORT TERM COURSES ON LOCAL LANGUAGES, MUSIC, DANCE, ARTS & CRAFTS, COOKING, MEDICINE ETC. WHICH SHOULD NOT BE A FORMAL OR STRUCTURED COURSE/PROGRAMME (COURSES NOT EXCEEDING 6 MONTHS DURATION AND NOT ISSUED WITH A QUALIFYING CERTIFICATE/ DIPLOMA ETC).",
  "e-Tourist Visa 1 year (e-T1 V) - RECREATION/SIGHT-SEEING",
  "e-Tourist Visa 30 days (e-T1 V) - MEETING FRIENDS/RELATIVES",
  "e-Tourist Visa 30 days (e-T1 V) - TOURISM,RECREATION,SIGHT-SEEING",
  "e-Tourist Visa 30 days (e-T1 V) - VOLUNTARY WORK OF SHORT DURATION (FOR A MAXIMUM PERIOD OF ONE MONTH, WHICH DO NOT INVOLVE ANY MONETARY PAYMENT OR CONSIDERATION OF ANY KIND IN RETURN).",
  "e-Tourist Visa 30 days (e-T1 V) - SHORT TERM COURSES ON LOCAL LANGUAGES, MUSIC, DANCE, ARTS & CRAFTS, COOKING, MEDICINE ETC. WHICH SHOULD NOT BE A FORMAL OR STRUCTURED COURSE/PROGRAMME (COURSES NOT EXCEEDING 6 MONTHS DURATION AND NOT ISSUED WITH A QUALIFYING CERTIFICATE/ DIPLOMA ETC).",
  "e-Tourist Visa 30 days (e-T1 V) - SHORT TERM YOGA PROGRAMME",
  "e-Tourist Visa 5 year (e-T1 V) - SHORT TERM YOGA PROGRAMME",
  "e-Tourist Visa 5 year (e-T1 V) - RECREATION/SIGHT-SEEING",
  "e-Tourist Visa 5 year (e-T1 V) - MEETING FRIENDS/RELATIVES",
  "e-Tourist Visa 5 year (e-T1 V) - VOLUNTARY WORK OF SHORT DURATION (FOR A MAXIMUM PERIOD OF ONE MONTH, WHICH DO NOT INVOLVE ANY MONETARY PAYMENT OR CONSIDERATION OF ANY KIND IN RETURN).",
  "e-Tourist Visa 5 year (e-T1 V) - SHORT TERM COURSES ON LOCAL LANGUAGES, MUSIC, DANCE, ARTS & CRAFTS, COOKING, MEDICINE ETC. WHICH SHOULD NOT BE A FORMAL OR STRUCTURED COURSE/PROGRAMME (COURSES NOT EXCEEDING 6 MONTHS DURATION AND NOT ISSUED WITH A QUALIFYING CERTIFICATE/ DIPLOMA ETC).",
  "e-Tourist Visa (e-T2 V) - FOR MOUNTAINEERING /TREKKING EXPEDITION.",
  "e-Tourist Visa (e-T2 V - 6 Months) - FOR MOUNTAINEERING / TREKKING EXPEDITION",
  "e-Transit Visa (e-TR V) - FOR SOLE PURPOSE OF ENABLING HIM/HER TRAVEL THROUGH INDIA TO A DESTINATION OUTSIDE INDIA."
];
export const RELIGIONS = [
  "BUDDHISM",
  "CHRISTIANITY",
  "HINDUISM",
  "ISLAM",
  "JAINISM",
  "PARSI",
  "SIKH",
  "ZOROASTRIAN",
  "OTHERS"
];
export const EDUCATIONS = [
  "BELOW MATRICULATION",
  "GRADUATE",
  "HIGHER SECONDARY",
  "ILLITERATE",
  "MATRICULATION",
  "POST GRADUATE",
  "PROFESSIONAL",
  "OTHERS"
];
export const MARITAL_STATUSES = [
  "SINGLE",
  "MARRIED",
  "UNMARRIED",
  "DIVORCED",
  "SEPARATED",
  "WIDOWED"
];
export const PASSPORT_TYPES = [
  "ORDINARY PASSPORT",
  "OFFICIAL PASSPORT",
  "DIPLOMATIC PASSPORT",
  "SERVICE PASSPORT",
  "SPECIAL PASSPORT"
];

export const STEP_TITLES = [
  { step: 1, title: 'Application & Purpose', icon: '📝' },
  { step: 2, title: 'Personal Details', icon: '👤' },
  { step: 3, title: 'Passport Details', icon: '🛂' },
  { step: 4, title: 'Contact & Address', icon: '🏠' },
  { step: 5, title: 'Family & Occupation', icon: '👨‍👩‍👧‍👦' },
  { step: 6, title: 'Travel & Declarations', icon: '✈️' },
];

export const questionDefinitions: Question[] = [
  // ============================================================
  // STEP 1: E-VISA APPLICATION & PURPOSE
  // ============================================================
  {
    id: 'heading_evisa_app',
    step: 1,
    type: 'heading',
    label: 'e-Visa Application',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'nationality',
    step: 1,
    type: 'select',
    label: '*Nationality/Region',
    tooltip: 'Select the nationality shown on your passport.',
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, 'Nationality is required'),
  },
  {
    id: 'passportType',
    step: 1,
    type: 'select',
    label: '*Passport type',
    tooltip: 'Most travelers hold an Ordinary Passport.',
    options: PASSPORT_TYPES,
    dependsOn: null,
    validation: z.string().min(1, 'Passport type is required'),
  },
  {
    id: 'portOfArrival',
    step: 1,
    type: 'select',
    label: '*Port Of Arrival',
    tooltip: 'Select your initial airport, seaport, or landport of entry into India.',
    options: PORTS_OF_ARRIVAL,
    dependsOn: null,
    validation: z.string().min(1, 'Port of Arrival is required'),
  },
  {
    id: 'dobEvisa',
    step: 1,
    type: 'date',
    label: '*Date of Birth (DD/MM/YYYY)',
    placeholder: 'YYYY-MM-DD',
    dependsOn: null,
    validation: z.string().min(1, 'Date of Birth is required'),
  },
  {
    id: 'visitingIndiaFor',
    step: 1,
    type: 'select',
    label: '*Visiting India for',
    tooltip: 'Select the primary duration and category of your visit.',
    options: VISA_PURPOSES,
    dependsOn: null,
    validation: z.string().min(1, 'Purpose of visit is required'),
  },
  {
    id: 'expectedArrivalDate',
    step: 1,
    type: 'date',
    label: '*Expected Date of Arrival (DD/MM/YYYY)',
    placeholder: 'YYYY-MM-DD',
    tooltip: 'Should be at least 4 days ahead for standard e-Visa processing.',
    dependsOn: null,
    validation: z.string().min(1, 'Expected Date of Arrival is required'),
  },

  // ============================================================
  // STEP 2: APPLICANT PERSONAL DETAILS
  // ============================================================
  {
    id: 'heading_applicant_details',
    step: 2,
    type: 'heading',
    label: 'Applicant Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'surname',
    step: 2,
    type: 'text',
    label: 'Surname (exactly as in your Passport)',
    placeholder: 'e.g., ATHAPATHTHU',
    tooltip: 'Must match the machine-readable zone of your passport exactly.',
    dependsOn: null,
    validation: z.string().min(1, 'Surname is required'),
  },
  {
    id: 'givenName',
    step: 2,
    type: 'text',
    label: '*Given Name/s (exactly as in your Passport)',
    placeholder: 'e.g., MADUSHKA HARSHANA',
    tooltip: 'Include first name and middle names as printed on passport.',
    dependsOn: null,
    validation: z.string().min(1, 'Given Name/s is required'),
  },
  {
    id: 'changedName',
    step: 2,
    type: 'checkbox',
    label: 'Have you ever changed your name? If yes, click the box and give details.',
    options: ['I have changed my name'],
    dependsOn: null,
    validation: z.array(z.string()).optional(),
  },
  {
    id: 'previousSurname',
    step: 2,
    type: 'text',
    label: 'Previous Surname',
    placeholder: 'e.g., PREVIOUS SURNAME',
    dependsOn: { field: 'changedName', value: ['I have changed my name'] },
    validation: z.string().optional(),
  },
  {
    id: 'previousGivenName',
    step: 2,
    type: 'text',
    label: 'Previous Given Name/s',
    placeholder: 'e.g., PREVIOUS GIVEN NAME',
    dependsOn: { field: 'changedName', value: ['I have changed my name'] },
    validation: z.string().optional(),
  },
  {
    id: 'gender',
    step: 2,
    type: 'radio',
    label: '*Gender',
    options: ['MALE', 'FEMALE', 'TRANSGENDER'],
    dependsOn: null,
    validation: z.string().min(1, 'Gender is required'),
  },
  {
    id: 'dobApplicant',
    step: 2,
    type: 'date',
    label: '*Date of Birth (DD/MM/YYYY)',
    placeholder: 'YYYY-MM-DD',
    dependsOn: null,
    validation: z.string().min(1, 'Date of Birth is required'),
  },
  {
    id: 'townCityBirth',
    step: 2,
    type: 'text',
    label: '*Town/City of birth',
    placeholder: 'e.g., COLOMBO',
    dependsOn: null,
    validation: z.string().min(1, 'Town/City of birth is required'),
  },
  {
    id: 'countryBirth',
    step: 2,
    type: 'select',
    label: '*Country/Region of birth',
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, 'Country/Region of birth is required'),
  },
  {
    id: 'citizenshipId',
    step: 2,
    type: 'text',
    label: '*Citizenship/National ID No.',
    placeholder: 'e.g., 123456789V',
    tooltip: 'Type NA if your country does not issue national ID cards.',
    dependsOn: null,
    validation: z.string().min(1, 'Citizenship/National ID is required'),
  },
  {
    id: 'religion',
    step: 2,
    type: 'select',
    label: '*Religion',
    options: RELIGIONS,
    dependsOn: null,
    validation: z.string().min(1, 'Religion is required'),
  },
  {
    id: 'visibleMarks',
    step: 2,
    type: 'text',
    label: '*Visible identification marks (Type NA if not applicable)',
    placeholder: 'e.g., NONE',
    tooltip: 'Specify any visible mole, scar, or tattoo. Type NA if none.',
    dependsOn: null,
    validation: z.string().min(1, 'Visible identification marks is required'),
  },
  {
    id: 'highestEducation',
    step: 2,
    type: 'select',
    label: '*Highest Educational Qualification',
    options: EDUCATIONS,
    dependsOn: null,
    validation: z.string().min(1, 'Highest Educational Qualification is required'),
  },
  {
    id: 'qualificationCollege',
    step: 2,
    type: 'text',
    label: '*Qualification acquired from College/University Name',
    placeholder: 'e.g., University of Colombo',
    dependsOn: null,
    validation: z.string().min(1, 'Qualification from College/University is required'),
  },
  {
    id: 'nationalityRegion',
    step: 2,
    type: 'select',
    label: '*Nationality/Region',
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, 'Nationality/Region is required'),
  },
  {
    id: 'nationalityAcquisition',
    step: 2,
    type: 'select',
    label: '*Did you acquire Nationality by birth or by naturalization?',
    options: ['BY BIRTH', 'BY NATURALIZATION'],
    dependsOn: null,
    validation: z.string().min(1, 'Nationality acquisition is required'),
  },
  {
    id: 'previousNationality',
    step: 2,
    type: 'select',
    label: 'Previous Nationality',
    options: COUNTRIES,
    dependsOn: { field: 'nationalityAcquisition', value: 'BY NATURALIZATION' },
    validation: z.string().optional(),
  },

  // ============================================================
  // STEP 3: PASSPORT DETAILS
  // ============================================================
  {
    id: 'heading_passport_details',
    step: 3,
    type: 'heading',
    label: 'Passport Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'passportNumber',
    step: 3,
    type: 'text',
    label: '*Passport Number',
    placeholder: 'e.g., N12345678',
    tooltip: 'Enter passport number without spaces or dashes.',
    dependsOn: null,
    validation: z.string().min(1, 'Passport Number is required'),
  },
  {
    id: 'passportPlaceIssue',
    step: 3,
    type: 'text',
    label: '*Place of Issue',
    placeholder: 'e.g., COLOMBO',
    dependsOn: null,
    validation: z.string().min(1, 'Place of Issue is required'),
  },
  {
    id: 'passportDateIssue',
    step: 3,
    type: 'date',
    label: '*Date of Issue',
    placeholder: 'YYYY-MM-DD',
    dependsOn: null,
    validation: z.string().min(1, 'Date of Issue is required'),
  },
  {
    id: 'passportDateExpiry',
    step: 3,
    type: 'date',
    label: '*Date of Expiry',
    placeholder: 'YYYY-MM-DD',
    tooltip: 'Passport must be valid for at least 6 months from your expected arrival date.',
    dependsOn: null,
    validation: z.string().min(1, 'Date of Expiry is required'),
  },
  {
    id: 'livedTwoYearsInApplyCountry',
    step: 3,
    type: 'radio',
    label: '*Have you lived for at least two years in the country where you are applying visa?',
    tooltip: 'Select YES if you have lived in your current country of application for 2+ years.',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'otherPassportIC',
    step: 3,
    type: 'radio',
    label: 'Any other valid Passport/Identity Certificate (IC) held?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'otherPassportCountry',
    step: 3,
    type: 'select',
    label: 'Country of Issue of Other Passport/IC',
    options: COUNTRIES,
    dependsOn: { field: 'otherPassportIC', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'otherPassportNo',
    step: 3,
    type: 'text',
    label: 'Passport/IC No.',
    placeholder: 'e.g., P98765432',
    dependsOn: { field: 'otherPassportIC', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'otherPassportDateIssue',
    step: 3,
    type: 'date',
    label: 'Date of Issue of Other Passport/IC',
    placeholder: 'YYYY-MM-DD',
    dependsOn: { field: 'otherPassportIC', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'otherPassportPlaceIssue',
    step: 3,
    type: 'text',
    label: 'Place of Issue of Other Passport/IC',
    placeholder: 'e.g., COLOMBO',
    dependsOn: { field: 'otherPassportIC', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'otherPassportNationality',
    step: 3,
    type: 'select',
    label: 'Nationality in Other Passport/IC',
    options: COUNTRIES,
    dependsOn: { field: 'otherPassportIC', value: 'YES' },
    validation: z.string().optional(),
  },
  
  // ============================================================
  // STEP 4: CONTACT & ADDRESS DETAILS
  // ============================================================
  {
    id: 'heading_applicant_address',
    step: 4,
    type: 'heading',
    label: 'Applicants Address Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'subheading_address_present',
    step: 4,
    type: 'subheading',
    label: 'Present Address',
    dependsOn: null,
    validation: z.string().optional(),
    isSubHeading: true,
  },
  {
    id: 'houseNoStreet',
    step: 4,
    type: 'text',
    label: '*House No./Street',
    placeholder: 'e.g., NO 259, HAVELOCK ROAD',
    dependsOn: null,
    validation: z.string().min(1, 'House No./Street is required'),
  },
  {
    id: 'villageTownCity',
    step: 4,
    type: 'text',
    label: '*Village/Town/City',
    placeholder: 'e.g., COLOMBO 06',
    dependsOn: null,
    validation: z.string().min(1, 'Village/Town/City is required'),
  },
  {
    id: 'addressCountry',
    step: 4,
    type: 'select',
    label: '*Country',
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, 'Country is required'),
  },
  {
    id: 'stateProvinceDistrict',
    step: 4,
    type: 'text',
    label: '*State/Province/District',
    placeholder: 'e.g., WESTERN PROVINCE',
    dependsOn: null,
    validation: z.string().min(1, 'State/Province/District is required'),
  },
  {
    id: 'postalZipCode',
    step: 4,
    type: 'text',
    label: '*Postal/Zip Code',
    placeholder: 'e.g., 00600',
    dependsOn: null,
    validation: z.string().min(1, 'Postal/Zip Code is required'),
  },
  {
    id: 'phoneNo',
    step: 4,
    type: 'tel',
    label: '*Phone No.',
    placeholder: 'e.g., 94112123456',
    dependsOn: null,
    validation: z.string().min(1, 'Phone No. is required'),
  },
  {
    id: 'mobileNo',
    step: 4,
    type: 'tel',
    label: '*Mobile No.',
    placeholder: 'e.g., 94701234567',
    dependsOn: null,
    validation: z.string().min(1, 'Mobile No. is required'),
  },
  {
    id: 'emailAddress',
    step: 4,
    type: 'email',
    label: 'Email address',
    placeholder: 'e.g., applicant@email.com',
    dependsOn: null,
    validation: z.string().email('Invalid email address').optional(),
  },
  {
    id: 'sameAddress',
    step: 4,
    type: 'radio',
    label: 'Click yes if your Permanent Address is same as your Present Address',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().optional(),
  },

  // ----- Permanent Address (Sub Heading - Conditional) -----
  {
    id: 'subheading_permanent_address',
    step: 4,
    type: 'subheading',
    label: 'Permanent Address',
    dependsOn: { field: 'sameAddress', value: 'NO' },
    validation: z.string().optional(),
    isSubHeading: true,
  },
  {
    id: 'permHouseNoStreet',
    step: 4,
    type: 'text',
    label: '*House No./Street',
    placeholder: 'e.g., NO 123, MAIN STREET',
    dependsOn: { field: 'sameAddress', value: 'NO' },
    validation: z.string().optional(),
  },
  {
    id: 'permVillageTownCity',
    step: 4,
    type: 'text',
    label: 'Village/Town/City',
    placeholder: 'e.g., KANDY',
    dependsOn: { field: 'sameAddress', value: 'NO' },
    validation: z.string().optional(),
  },
  {
    id: 'permStateProvinceDistrict',
    step: 4,
    type: 'text',
    label: 'State/Province/District',
    placeholder: 'e.g., CENTRAL PROVINCE',
    dependsOn: { field: 'sameAddress', value: 'NO' },
    validation: z.string().optional(),
  },
  {
    id: 'permCountry',
    step: 4,
    type: 'select',
    label: 'Country/Region',
    options: COUNTRIES,
    dependsOn: { field: 'sameAddress', value: 'NO' },
    validation: z.string().optional(),
  },

  // ============================================================
  // STEP 5: FAMILY & OCCUPATION DETAILS
  // ============================================================
  {
    id: 'heading_family_details',
    step: 5,
    type: 'heading',
    label: 'Family Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'subheading_father_details',
    step: 5,
    type: 'subheading',
    label: "Father's Details",
    dependsOn: null,
    validation: z.string().optional(),
    isSubHeading: true,
  },
  {
    id: 'fatherName',
    step: 5,
    type: 'text',
    label: "*Father's Name",
    placeholder: 'e.g., A. ATHAPATHTHU',
    dependsOn: null,
    validation: z.string().min(1, "Father's Name is required"),
  },
  {
    id: 'fatherNationalityReligion',
    step: 5,
    type: 'select',
    label: "*Father's Nationality/Region",
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, "Father's Nationality is required"),
  },
  {
    id: 'fatherPrevNationality',
    step: 5,
    type: 'select',
    label: "Father's Previous Nationality/Region",
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'fatherPlaceOfBirth',
    step: 5,
    type: 'text',
    label: "*Father's Place of Birth",
    placeholder: 'e.g., COLOMBO',
    dependsOn: null,
    validation: z.string().min(1, "Father's Place of Birth is required"),
  },
  {
    id: 'fatherCountryBirth',
    step: 5,
    type: 'select',
    label: "*Father's Country/Region of birth",
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, "Father's Country of Birth is required"),
  },
  {
    id: 'subheading_mother_details',
    step: 5,
    type: 'subheading',
    label: "Mother's Details",
    dependsOn: null,
    validation: z.string().optional(),
    isSubHeading: true,
  },
  {
    id: 'motherName',
    step: 5,
    type: 'text',
    label: "*Mother's Name",
    placeholder: 'e.g., A ATHAPATHTHU',
    dependsOn: null,
    validation: z.string().min(1, "Mother's Name is required"),
  },
  {
    id: 'motherNationalityReligion',
    step: 5,
    type: 'select',
    label: "*Mother's Nationality/Region",
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, "Mother's Nationality is required"),
  },
  {
    id: 'motherPrevNationality',
    step: 5,
    type: 'select',
    label: "Mother's Previous Nationality/Region",
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'motherPlaceOfBirth',
    step: 5,
    type: 'text',
    label: "*Mother's Place of Birth",
    placeholder: 'e.g., COLOMBO',
    dependsOn: null,
    validation: z.string().min(1, "Mother's Place of Birth is required"),
  },
  {
    id: 'motherCountryBirth',
    step: 5,
    type: 'select',
    label: "*Mother's Country/Region of birth",
    options: COUNTRIES,
    dependsOn: null,
    validation: z.string().min(1, "Mother's Country of Birth is required"),
  },
  {
    id: 'maritalStatus',
    step: 5,
    type: 'select',
    label: '*Applicant’s Marital Status',
    options: MARITAL_STATUSES,
    dependsOn: null,
    validation: z.string().min(1, 'Marital Status is required'),
  },
  {
    id: 'heading_spouse_details',
    step: 5,
    type: 'heading',
    label: "Spouse's Details",
    dependsOn: { field: 'maritalStatus', value: 'MARRIED' },
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'spouseName',
    step: 5,
    type: 'text',
    label: "*Spouse's Name",
    placeholder: 'e.g., Spouse Name',
    dependsOn: { field: 'maritalStatus', value: 'MARRIED' },
    validation: z.string().optional(),
  },
  {
    id: 'spouseNationality',
    step: 5,
    type: 'select',
    label: "*Spouse's Nationality/Region",
    options: COUNTRIES,
    dependsOn: { field: 'maritalStatus', value: 'MARRIED' },
    validation: z.string().optional(),
  },
  {
    id: 'spousePrevNationality',
    step: 5,
    type: 'select',
    label: "Spouse's Previous Nationality/Region",
    options: COUNTRIES,
    dependsOn: { field: 'maritalStatus', value: 'MARRIED' },
    validation: z.string().optional(),
  },
  {
    id: 'spousePlaceOfBirth',
    step: 5,
    type: 'text',
    label: "*Spouse's Place of birth",
    placeholder: 'e.g., COLOMBO',
    dependsOn: { field: 'maritalStatus', value: 'MARRIED' },
    validation: z.string().optional(),
  },
  {
    id: 'spouseCountryBirth',
    step: 5,
    type: 'select',
    label: "*Spouse's Country/Region of birth",
    options: COUNTRIES,
    dependsOn: { field: 'maritalStatus', value: 'MARRIED' },
    validation: z.string().optional(),
  },
  {
    id: 'parentsPakistan',
    step: 5,
    type: 'radio',
    label: '*Were your Parents/Grandparents (paternal/maternal) Pakistan Nationals or Belong to Pakistan held area?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'pakistanDetails',
    step: 5,
    type: 'text',
    label: 'Details of Pakistan connection',
    placeholder: 'e.g., Grandfather born in Lahore',
    dependsOn: { field: 'parentsPakistan', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'heading_profession',
    step: 5,
    type: 'heading',
    label: 'Profession / Occupation Details of Applicant',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'presentOccupation',
    step: 5,
    type: 'text',
    label: '*Present Occupation',
    placeholder: 'e.g., BUSINESS PERSON',
    dependsOn: null,
    validation: z.string().min(1, 'Present Occupation is required'),
  },
  {
    id: 'occupationDetailsOf',
    step: 5,
    type: 'select',
    label: '*Specify below occupation details of',
    options: ['Self', 'Father', 'Spouse'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'employerName',
    step: 5,
    type: 'text',
    label: '*Employer Name/business',
    placeholder: 'e.g., COMPANY NAME',
    dependsOn: null,
    validation: z.string().min(1, 'Employer Name is required'),
  },
  {
    id: 'designation',
    step: 5,
    type: 'text',
    label: 'Designation',
    placeholder: 'e.g., MANAGER',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'employerAddress',
    step: 5,
    type: 'text',
    label: '*Employer/company Address',
    placeholder: 'e.g., 01, HAVELOCK RD, COL 06',
    dependsOn: null,
    validation: z.string().min(1, 'Employer Address is required'),
  },
  {
    id: 'employerPhone',
    step: 5,
    type: 'tel',
    label: 'Phone No.',
    placeholder: 'e.g., 94701234567',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'pastOccupation',
    step: 5,
    type: 'text',
    label: 'Past Occupation, if any',
    placeholder: 'e.g., ENGINEER',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'militaryService',
    step: 5,
    type: 'radio',
    label: 'Are/were you in a Military/Semi-Military/Police/Security Organization?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'militaryOrganization',
    step: 5,
    type: 'text',
    label: 'Organization Name',
    placeholder: 'e.g., SRI LANKA AIR FORCE',
    dependsOn: { field: 'militaryService', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'militaryDesignation',
    step: 5,
    type: 'text',
    label: 'Designation',
    placeholder: 'e.g., OFFICER',
    dependsOn: { field: 'militaryService', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'militaryRank',
    step: 5,
    type: 'text',
    label: 'Rank',
    placeholder: 'e.g., CAPTAIN',
    dependsOn: { field: 'militaryService', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'militaryPosting',
    step: 5,
    type: 'text',
    label: 'Place of Posting',
    placeholder: 'e.g., COLOMBO',
    dependsOn: { field: 'militaryService', value: 'YES' },
    validation: z.string().optional(),
  },

  // ============================================================
  // STEP 6: TRAVEL HISTORY, VISA DETAILS & DECLARATIONS
  // ============================================================
  {
    id: 'heading_visa_sought',
    step: 6,
    type: 'heading',
    label: 'Details of Visa Sought',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'placesToVisit',
    step: 6,
    type: 'text',
    label: '*Places to be visited in India',
    placeholder: 'e.g., DELHI, MUMBAI',
    dependsOn: null,
    validation: z.string().min(1, 'Places to visit is required'),
  },
  {
    id: 'bookedHotel',
    step: 6,
    type: 'radio',
    label: 'Have you booked any room in Hotel/Resort etc. through any Tour Operator?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'tourOperatorName',
    step: 6,
    type: 'text',
    label: 'Name of the tour operator',
    placeholder: 'e.g., mySky Travels',
    dependsOn: { field: 'bookedHotel', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'tourOperatorAddress',
    step: 6,
    type: 'text',
    label: 'Address of the tour operator',
    placeholder: 'e.g., 123, Main Road',
    dependsOn: { field: 'bookedHotel', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'hotelName',
    step: 6,
    type: 'text',
    label: 'Name of the Hotel/Resort etc',
    placeholder: 'e.g., Hilton',
    dependsOn: { field: 'bookedHotel', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'hotelPlaceCity',
    step: 6,
    type: 'text',
    label: 'Place/City of Hotel/Resort etc',
    placeholder: 'e.g., DELHI',
    dependsOn: { field: 'bookedHotel', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'portArrivalIndia',
    step: 6,
    type: 'select',
    label: '*Port of Arrival in India',
    options: PORTS_OF_ARRIVAL,
    dependsOn: null,
    validation: z.string().min(1, 'Port of Arrival is required'),
  },
  {
    id: 'portExitIndia',
    step: 6,
    type: 'select',
    label: 'Expected Port of Exit from India',
    options: PORTS_OF_ARRIVAL,
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'heading_previous_visa',
    step: 6,
    type: 'heading',
    label: 'Previous Visa/Currently valid Visa Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'visitedIndiaBefore',
    step: 6,
    type: 'radio',
    label: '*Have you ever visited India before?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'prevIndiaAddressStayed',
    step: 6,
    type: 'text',
    label: '*Address of the place stayed',
    placeholder: 'e.g., Hotel Taj, Mumbai',
    dependsOn: { field: 'visitedIndiaBefore', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'prevIndiaCitiesVisited',
    step: 6,
    type: 'text',
    label: '*Cities previously visited in India',
    placeholder: 'e.g., CHENNAI, DELHI, MUMBAI',
    dependsOn: { field: 'visitedIndiaBefore', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'prevIndianVisaNo',
    step: 6,
    type: 'text',
    label: '*Last Indian Visa No/Currently valid Indian Visa No.',
    placeholder: 'e.g., 123456789',
    dependsOn: { field: 'visitedIndiaBefore', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'prevVisaType',
    step: 6,
    type: 'text',
    label: '*Type of Visa',
    placeholder: 'e.g., TOURIST VISA',
    dependsOn: { field: 'visitedIndiaBefore', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'prevVisaPlaceIssue',
    step: 6,
    type: 'text',
    label: '*Place of Visa Issue',
    placeholder: 'e.g., COLOMBO',
    dependsOn: { field: 'visitedIndiaBefore', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'prevVisaDateIssue',
    step: 6,
    type: 'date',
    label: '*Date of Issue (DD/MM/YYYY)',
    placeholder: 'YYYY-MM-DD',
    dependsOn: { field: 'visitedIndiaBefore', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'refusedVisaExtension',
    step: 6,
    type: 'radio',
    label: 'Has permission to visit or to extend stay in India previously been refused?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'refusedVisaDetails',
    step: 6,
    type: 'text',
    label: 'Details of refusal/rejection',
    placeholder: 'e.g., Mention details',
    dependsOn: { field: 'refusedVisaExtension', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'heading_other_info',
    step: 6,
    type: 'heading',
    label: 'Other Information',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'countriesVisited',
    step: 6,
    type: 'textarea',
    label: 'Countries Visited in Last 10 years',
    placeholder: 'e.g., INDIA, INDONESIA, JAPAN, ENGLAND',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'heading_saarc',
    step: 6,
    type: 'heading',
    label: 'SAARC Country Visit Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'visitedSaarc',
    step: 6,
    type: 'radio',
    label: 'Have you visited Afghanistan, Bangladesh, Bhutan, India, Maldives, Nepal, Pakistan, Sri Lanka (except your own country) during last 3 years?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'saarcCountriesVisited',
    step: 6,
    type: 'text',
    label: '*Provide the country you visited',
    placeholder: 'e.g., INDIA, NEPAL',
    dependsOn: { field: 'visitedSaarc', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'saarcYearVisited',
    step: 6,
    type: 'text',
    label: 'Year of Visit',
    placeholder: 'e.g., 2024',
    dependsOn: { field: 'visitedSaarc', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'saarcNoVisits',
    step: 6,
    type: 'text',
    label: 'Number of Visits',
    placeholder: 'e.g., 2',
    dependsOn: { field: 'visitedSaarc', value: 'YES' },
    validation: z.string().optional(),
  },
  {
    id: 'heading_reference',
    step: 6,
    type: 'heading',
    label: 'Reference Details',
    dependsOn: null,
    validation: z.string().optional(),
    isHeading: true,
  },
  {
    id: 'hotelNameIndia',
    step: 6,
    type: 'text',
    label: 'Reference Name / Hotel Name in India',
    placeholder: 'e.g., Taj Coromandel',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'hotelAddressIndia',
    step: 6,
    type: 'text',
    label: 'Address of Reference / Hotel in India',
    placeholder: 'e.g., 123, MG Road, Mumbai',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'referenceNameHome',
    step: 6,
    type: 'text',
    label: 'Reference Name in Country of Residence',
    placeholder: 'e.g., John Doe',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'referenceAddressHome',
    step: 6,
    type: 'text',
    label: 'Address of Reference in Country of Residence',
    placeholder: 'e.g., 456, Galle Road, Colombo',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'arrested',
    step: 6,
    type: 'radio',
    label: 'Have you ever been arrested/ prosecuted/ convicted by Court of Law of any country?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'refusedEntryDeported',
    step: 6,
    type: 'radio',
    label: 'Have you ever been refused entry / deported by any country including India?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'humanTrafficking',
    step: 6,
    type: 'radio',
    label: 'Have you ever been engaged in Human trafficking/Drug trafficking/Child abuse/Crime against women/Economic offense/Financial fraud?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'cyberCrimeTerrorism',
    step: 6,
    type: 'radio',
    label: 'Have you ever been engaged in Cyber crime/Terrorist activities/ Sabotage/ Espionage/ Genocide/Political Killing/ other act of violence?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'glorifyTerror',
    step: 6,
    type: 'radio',
    label: 'Have you ever by any means or medium, expressed views that justify or glorify terrorist violence or that may encourage others to terrorist acts or other serious criminal acts?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  {
    id: 'soughtAsylum',
    step: 6,
    type: 'radio',
    label: 'Have you sought asylum (political or otherwise) in any country?',
    options: ['YES', 'NO'],
    dependsOn: null,
    validation: z.string().min(1, 'Please select an option'),
  },
  // ============================================================
  // BUSINESS VISA CONDITIONAL DETAILS
  // ============================================================
  {
    id: 'indianCompanyName',
    step: 6,
    type: 'text',
    label: '*Name of Indian Host Company / Organization',
    placeholder: 'e.g. TATA CONSULTANCY SERVICES LTD',
    tooltip: 'Enter the registered name of the host company in India.',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'indianCompanyAddress',
    step: 6,
    type: 'textarea',
    label: '*Address of Indian Host Company / Organization',
    placeholder: 'e.g. Plot 45, Tech Park, Cyber City, Gurugram, Haryana',
    tooltip: 'Full physical address of the host company in India.',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'indianCompanyWebsite',
    step: 6,
    type: 'text',
    label: 'Website of Indian Host Company (Optional)',
    placeholder: 'e.g. www.tataconsultancy.com',
    dependsOn: null,
    validation: z.string().optional(),
  },

  // ============================================================
  // MEDICAL VISA CONDITIONAL DETAILS
  // ============================================================
  {
    id: 'indianHospitalName',
    step: 6,
    type: 'text',
    label: '*Name of Hospital in India',
    placeholder: 'e.g. APOLLO HOSPITALS CHENNAI',
    tooltip: 'Name of the hospital where treatment will be received.',
    dependsOn: null,
    validation: z.string().optional(),
  },
  {
    id: 'indianHospitalAddress',
    step: 6,
    type: 'textarea',
    label: '*Address of Hospital in India',
    placeholder: 'e.g. 21 Greams Lane, Thousand Lights, Chennai, Tamil Nadu',
    tooltip: 'Full address of the hospital in India.',
    dependsOn: null,
    validation: z.string().optional(),
  },

  {
    id: 'declarationCheckbox',
    step: 6,
    type: 'checkbox',
    label: '*I hereby declare that the information furnished above is correct to the best of my knowledge and belief. In the event of any information being found false or incorrect, I shall bear full responsibility for the consequences.',
    options: ['I Agree'],
    dependsOn: null,
    validation: z.array(z.string()).min(1, 'You must agree to the declaration'),
  },
  {
    id: 'fullNameCompleting',
    step: 6,
    type: 'text',
    label: '*Full Name of the Person Completing this Application',
    placeholder: 'e.g., MADUSHKA HARSHANA ATHAPATHTHU',
    dependsOn: null,
    validation: z.string().min(1, 'Full name is required'),
  },
];

export const MALAYSIA_QUESTIONS: Question[] = [
  {
    id: 'category',
    step: 1,
    type: 'select',
    label: '*Select e-VISA Category',
    options: [
      'e-VISA Tourist (30 Days - Single Entry)',
      'e-VISA Tourist (30 Days - Multiple Entry)',
      'e-VISA Student / Expatriate',
    ],
    dependsOn: null,
  },
  {
    id: 'surname',
    step: 2,
    type: 'text',
    label: '*Surname (as in Passport)',
    placeholder: 'e.g. ATHAPATHTHU',
    dependsOn: null,
  },
  {
    id: 'givenName',
    step: 2,
    type: 'text',
    label: '*Given Name/s (as in Passport)',
    placeholder: 'e.g. MADUSHKA HARSHANA',
    dependsOn: null,
  },
  {
    id: 'passportNumber',
    step: 2,
    type: 'text',
    label: '*Passport Number',
    placeholder: 'e.g. N12345678',
    dependsOn: null,
  },
  {
    id: 'nationality',
    step: 2,
    type: 'select',
    label: '*Nationality',
    options: COUNTRIES,
    dependsOn: null,
  },
  {
    id: 'gender',
    step: 2,
    type: 'radio',
    label: '*Gender',
    options: ['MALE', 'FEMALE', 'OTHER'],
    dependsOn: null,
  },
  {
    id: 'dob',
    step: 2,
    type: 'date',
    label: '*Date of Birth',
    dependsOn: null,
  },
  {
    id: 'passportExpiry',
    step: 2,
    type: 'date',
    label: '*Passport Expiry Date',
    dependsOn: null,
  },
  {
    id: 'flightArrivalDate',
    step: 3,
    type: 'date',
    label: '*Flight Arrival Date in Malaysia',
    dependsOn: null,
  },
  {
    id: 'flightDepartureDate',
    step: 3,
    type: 'date',
    label: '*Flight Departure Date from Malaysia',
    dependsOn: null,
  },
  {
    id: 'airline',
    step: 3,
    type: 'text',
    label: '*Airline Name',
    placeholder: 'e.g. SriLankan Airlines / Malaysia Airlines',
    dependsOn: null,
  },
  {
    id: 'flightNumber',
    step: 3,
    type: 'text',
    label: '*Flight Number',
    placeholder: 'e.g. UL 314',
    dependsOn: null,
  },
  {
    id: 'malaysiaHotelAddress',
    step: 3,
    type: 'textarea',
    label: '*Intended Accommodation / Hotel Address in Malaysia',
    placeholder: 'e.g. Hilton Kuala Lumpur, 3 Jalan Stesen Sentral, KL',
    dependsOn: null,
  },
];

export const VIETNAM_QUESTIONS: Question[] = [
  {
    id: 'visaType',
    step: 1,
    type: 'select',
    label: '*Select e-Visa Type',
    options: [
      'Vietnam e-Visa (30 Days - Single Entry)',
      'Vietnam e-Visa (30 Days - Multiple Entry)',
      'Vietnam e-Visa (90 Days - Multiple Entry)',
    ],
    dependsOn: null,
  },
  {
    id: 'surname',
    step: 2,
    type: 'text',
    label: 'Surname (Last name)',
    placeholder: 'e.g. MUNAWEERA THANTHRIGE',
    tooltip: 'Enter name as on the ICAO line in the passport.',
    dependsOn: null,
  },
  {
    id: 'givenName',
    step: 2,
    type: 'text',
    label: '*Middle and given name (First name)',
    placeholder: 'e.g. YASHMI NAVODA',
    dependsOn: null,
  },
  {
    id: 'dob',
    step: 2,
    type: 'date',
    label: '*Date of birth',
    dependsOn: null,
  },
  {
    id: 'gender',
    step: 2,
    type: 'select',
    label: '*Sex',
    options: ['Female', 'Male'],
    dependsOn: null,
  },
  {
    id: 'nationality',
    step: 2,
    type: 'select',
    label: '*Nationality',
    options: COUNTRIES,
    dependsOn: null,
  },
  {
    id: 'identityCard',
    step: 2,
    type: 'text',
    label: 'Identity Card / ID Card (Optional)',
    placeholder: 'ID Card Number',
    dependsOn: null,
  },
  {
    id: 'email',
    step: 2,
    type: 'text',
    label: '*Email Address',
    placeholder: 'e.g. myskydestinations@gmail.com',
    dependsOn: null,
  },
  {
    id: 'reEnterEmail',
    step: 2,
    type: 'text',
    label: '*Re-enter Email Address',
    placeholder: 'Re-enter Email',
    dependsOn: null,
  },
  {
    id: 'religion',
    step: 2,
    type: 'text',
    label: '*Religion',
    placeholder: 'e.g. Buddhism',
    dependsOn: null,
  },
  {
    id: 'placeOfBirth',
    step: 2,
    type: 'text',
    label: '*Place of birth',
    placeholder: 'e.g. COLOMBO',
    dependsOn: null,
  },
  {
    id: 'usedOtherPassports',
    step: 2,
    type: 'radio',
    label: 'Have you ever used any other passports to enter into Viet Nam?',
    options: ['No', 'Yes'],
    dependsOn: null,
  },
  {
    id: 'hasMultipleNationalities',
    step: 2,
    type: 'radio',
    label: 'Do you have multiple nationalities?',
    options: ['No', 'Yes'],
    dependsOn: null,
  },
  {
    id: 'lawViolation',
    step: 2,
    type: 'radio',
    label: 'Violation of the Vietnamese laws/regulations (if any)',
    options: ['No', 'Yes'],
    dependsOn: null,
  },
  {
    id: 'passportNumber',
    step: 3,
    type: 'text',
    label: '*Passport Number',
    placeholder: 'e.g. N12345678',
    dependsOn: null,
  },
  {
    id: 'passportType',
    step: 3,
    type: 'select',
    label: '*Passport Type',
    options: ['Ordinary Passport', 'Diplomatic Passport', 'Official Passport'],
    dependsOn: null,
  },
  {
    id: 'passportIssueDate',
    step: 3,
    type: 'date',
    label: 'Passport Date of Issue',
    dependsOn: null,
  },
  {
    id: 'passportExpiry',
    step: 3,
    type: 'date',
    label: '*Passport Expiry Date',
    dependsOn: null,
  },
  {
    id: 'occupation',
    step: 3,
    type: 'text',
    label: 'Occupation (Optional)',
    placeholder: 'e.g. BUSINESS PERSON / ENGINEER',
    dependsOn: null,
  },
  {
    id: 'intendedEntryDate',
    step: 3,
    type: 'date',
    label: '*Intended Date of Entry',
    dependsOn: null,
  },
  {
    id: 'intendedExitDate',
    step: 3,
    type: 'date',
    label: '*Intended Date of Exit',
    dependsOn: null,
  },
  {
    id: 'entryPort',
    step: 3,
    type: 'select',
    label: '*Allowed Entry Checkpoint (Port)',
    options: [
      'Hanoi - Noi Bai Int Airport (HAN)',
      'Ho Chi Minh City - Tan Son Nhat Int Airport (SGN)',
      'Da Nang Int Airport (DAD)',
      'Phu Quoc Int Airport (PQC)',
      'Nha Trang - Cam Ranh Int Airport (CXR)',
      'Cat Bi Int Airport - Hai Phong (HPH)',
      'Can Tho Int Airport (VCA)',
      'Lao Cai Landport (China Border)',
      'Moc Bai Landport (Cambodia Border)',
    ],
    dependsOn: null,
  },
  {
    id: 'exitPort',
    step: 3,
    type: 'select',
    label: '*Allowed Exit Checkpoint (Port)',
    options: [
      'Hanoi - Noi Bai Int Airport (HAN)',
      'Ho Chi Minh City - Tan Son Nhat Int Airport (SGN)',
      'Da Nang Int Airport (DAD)',
      'Phu Quoc Int Airport (PQC)',
      'Nha Trang - Cam Ranh Int Airport (CXR)',
      'Cat Bi Int Airport - Hai Phong (HPH)',
      'Can Tho Int Airport (VCA)',
      'Lao Cai Landport (China Border)',
      'Moc Bai Landport (Cambodia Border)',
    ],
    dependsOn: null,
  },
  {
    id: 'vietnamAddress',
    step: 3,
    type: 'textarea',
    label: '*Temporary Hotel / Residential Address in Vietnam',
    placeholder: 'e.g. Lotte Hotel Hanoi, 54 Lieu Giai, Ba Dinh, Hanoi',
    dependsOn: null,
  },
  {
    id: 'hasHostingOrg',
    step: 3,
    type: 'radio',
    label: 'Underneath hosting organization/agency/individual',
    options: ['No', 'Yes'],
    dependsOn: null,
  },
  {
    id: 'hasBeenToVietnamLastYear',
    step: 3,
    type: 'radio',
    label: 'Have you been to Viet Nam in the last 1 year?',
    options: ['No', 'Yes'],
    dependsOn: null,
  },
];

